import React from 'react'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css'
import { connect } from 'react-redux'
import { I18n } from 'react-redux-i18n'
import { debounce, get } from 'lodash'

import { fetchUsers, deleteUser } from '../../actions/remote_api'
import { withTableConfigs, withDeleteModal } from '../table'
import UserTableFilterPanel from './UserTableFilterPanel'

class UserTableContainer extends React.Component {
  abortController = null

  componentDidMount() {
    this.handleDataChange = debounce(this.handleDataChange, 1000)
  }

  componentWillUnmount() {
    this.abortInFlights()
  }

  abortInFlights() {
    if (this.abortController) {
      this.abortController.abort()
      this.abortController = undefined
    }
  }

  handleDataChange = (filter) => {
    this.abortInFlights()
    this.abortController = new AbortController()
    this.props.fetchUsers(
      {
        page: filter.currentPage,
        limit: filter.sizePerPage,
        sort: filter.sort,
        order: filter.order,
        ...this.createQueryFilter(filter.query),
      },
      { signal: this.abortController.signal },
    )
  }

  createQueryFilter = (filter) => {
    if (!filter) return undefined

    const queryfilter = {}
    if (filter.username) queryfilter.username_like = filter.username

    if (filter.displayName)
      queryfilter.displayName_like = filter.displayName

    if (filter.email) queryfilter.email_like = filter.email

    return queryfilter
  }

  render() {
    return <UserTable {...this.props} onDataChange={this.handleDataChange} />
  }
}

export default connect(
  ({ fetch }) => ({
    instances: get(fetch, 'user.list', []),
    totalCount: get(fetch, 'user.totalCount'),
  }),
  { fetchUsers, deleteInstance: deleteUser },
)(UserTableContainer)

let UserTable = ({
  defaultOptions,
  defaultSettings,
  detailLink,
  editButton,
  renderFilterPanel,
  renderToolbar,
}) => {
  const { fields, table } = I18n.t('userPage')
  return (
    <div>
      <h1 className="page-header">{table.header}</h1>
      {renderFilterPanel}
      {renderToolbar}
      <BootstrapTable {...defaultSettings} options={defaultOptions}>
        <TableHeaderColumn
          dataField="displayName"
          dataSort
          dataFormat={detailLink}
        >
          {fields.displayName}
        </TableHeaderColumn>
        <TableHeaderColumn dataField="username" dataSort>
          {fields.username}
        </TableHeaderColumn>
        <TableHeaderColumn dataField="email" dataSort>
          {fields.email}
        </TableHeaderColumn>
        <TableHeaderColumn dataField="role" dataSort dataFormat={renderRole}>
          {fields.roles}
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="edit"
          editable={false}
          dataFormat={editButton}
          width="100px"
          dataAlign="center"
          hiddenOnInsert
        />
      </BootstrapTable>
    </div>
  )
}

const renderRole = (_, row) => {
  if (row.roles) return row.roles.map((r) => r.toUpperCase())
  else return '-'
}

UserTable = withTableConfigs('user')(UserTable, UserTableFilterPanel)
// UserTable = withDetailPopupProvider(UserTable, UserDetailPopup)
UserTable = withDeleteModal(UserTable)
